import { breakpoints } from '@/utils/util-breakpoints';
import { createGlobalStyle } from 'styled-components';

export const ImagePreviewGlobalStyles = createGlobalStyle`
  .image-group-preview {
    height: 100dvh;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: ${({ theme: { token } }) => token.paddingLG}px ${({ theme: { token } }) => token.padding}px 136px ${({
  theme: { token },
}) => token.padding}px;
    gap: ${({ theme: { token } }) => token.marginLG}px;

    .image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      min-height: 0;
      flex-grow: 1;

      .ant-image-preview-img {
        max-width: 100%;
        max-height: 100%;
      }

      .arrow-button {
        border-radius: 50%;
        background-color: ${({ theme: { token } }) => token.carouselInsetArrowColorBg};
        color: ${({ theme: { token } }) => token.carouselInsetArrowColor};
        position: absolute;
        z-index: 1;
        top: 50%;
        transform: translateY(-50%);

        &.arrow-left {
          left: 0;
        }

        &.arrow-right {
          right: 0;
        }
      }
    }

    .image-group-header {
      padding-left: ${({ theme: { token } }) => token.paddingMD}px;
      text-align: left;
      color: ${({ theme: { token } }) => token.previewTextColor};

      @media (max-width: ${breakpoints.lg - 1}px) {
        padding-left: 0;
      }

      .image-title {
          color: ${({ theme: { token } }) => token.colorWhite};
          font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
          line-height: ${({ theme: { token } }) => token.lineHeightLG};
          font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
      }
    }
  }

  .ant-image-preview-switch-left, .ant-image-preview-switch-right {
    display: none;
  }

  .ant-image-preview-mask {
    background-color: ${({ theme: { token } }) => token.previewBackgroundColor} !important;
  }
`;
